<template>
  <section id="about" class="about">
    <h2 class="about_title">About Me</h2>
    <p class="about_body">
        I’m a resourceful and results-driven mobile and web developer, writer, and aspiring entrepreneur with a passion for innovation 
        and problem-solving. Whether building sleek digital experiences or crafting compelling content, I thrive on creating solutions 
        that deliver real value. I’m continuously exploring new technologies and ideas, always learning, and always pushing forward. My 
        work blends creativity with a strategic mindset—turning challenges into opportunities for growth and impact.
    </p>
    <div class="about_icons">
        <div class="skills">
            <img class="skills_icon" src="../assets/flutter_icon.png" alt="Flutter Icon" />
            <p class="skills_text">Flutter</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/dart_icon.png" alt="Dart Icon" />
            <p class="skills_text">Dart</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/kotlin_logo.png" alt="Kotlin Icon" />
            <p class="skills_text">Kotlin</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/android_icon.png" alt="Android Icon" />
            <p class="skills_text">Android</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/java_icon.png" alt="Java Icon" />
            <p class="skills_text">Java</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/python_icon.png" alt="Python Icon" />
            <p class="skills_text">Python</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/react.png" alt="React Icon" />
            <p class="skills_text">React</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/vue_icon.png" alt="Vue Icon" />
            <p class="skills_text">Vue</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/javaScript_icon.png" alt="JavaScript Icon" />
            <p class="skills_text">JavaScript</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/html_icon.png" alt="HTML Icon" />
            <p class="skills_text">HTML</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/css_icon.png" alt="CSS Icon" />
            <p class="skills_text">CSS</p>
        </div>

        <div class="skills">
            <img class="skills_icon" src="../assets/xml_icon.png" alt="XML Icon" />
            <p class="skills_text">XML</p>
        </div>
    </div>
  </section>
</template>

<script>
    // import { onMounted } from 'vue';
    // import particlesJS from 'particles.js';

    export default {
        name: 'AboutSection',
        setup() {
            // onMounted(() => {
            //     particlesJS('particles-js', {
            //         particles: {
            //             number: { value: 80 },
            //             size: { value: 3 },
            //             move: { speed: 1 }
            //         },
            //         interactivity: {
            //             events: {
            //                 onhover: { enable: true, mode: 'repulse' }
            //             }
            //         }
            //     });
            // });
        }
    }
</script>

<style scoped>
    .about {
        height: 100%;
        margin-left: 30px;
        margin-right: 30px;
        padding-top: 100px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

    .about_title{
        font-size: 42px;
        font-weight: 700;
        color: rgb(150, 8, 96);
        width: 80%;
    }

    .about_body{
        font-size: 24px;
        color: #A5A5A5;
        margin-top: 20px;
        text-align: left;
        width: 80%;
    }

    .about_icons{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 50px;
        width: 80%;
        margin-top: 50px;
    }

    .skills {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        padding: 50px;
        border: 2px solid black;
        border-radius: 20px;
        opacity: 0.7;
        background-color: rgb(73, 2, 46);
    }

    .skills:hover {
        animation: shake 0.5s ease-in-out;
        border: 5px solid black;
        background-color: rgb(150, 8, 96, 0.8);
    }

    .skills_icon {
        width: 60px;
        height: 60px;
        margin-bottom: 20px;
    }

    .skills_text {
        width: 90%;
        font-size: 20px;
        font-weight: 600;
        font-style: italic;
        color: rgb(244, 187, 222);
        text-align: center;
    }

    @keyframes shake {
        0% {
        transform: translateX(0);
        }
        25% {
        transform: translateX(-15px);
        }
        50% {
        transform: translateX(15px);
        }
        75% {
        transform: translateX(-15px);
        }
        100% {
        transform: translateX(0);
        }
    }

    @media (max-width: 1200px) {
        .about_icons {
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
            width: 80vw;
            margin-top: 30px;
        }
        
    }

    @media (max-width: 768px) {
        .about {
            padding-top: 100px;
        }

        .about_title {
            font-size: 32px;
            width: 100%;
        }

        .about_body {
            font-size: 18px;
            width: 100%;
            margin-top: 10px;
        }

        .about_icons{
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
            width: 100%;
            margin-top: 30px;
        }
        
        .skills {
            padding: 30px;
            border-radius: 20px;
        }

        .skills_icon {
            width: 35px;
            height: 35px;
            margin-bottom: 15px;
        }

        .skills_text {
            width: 60px;
            font-size: 18px;
            font-weight: 600;
        }
    }
</style>